(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-rsi-wo-scroll]');
    if (!trigger) return;

    var targetId = trigger.getAttribute('href');
    if (!targetId || targetId.charAt(0) !== '#') return;

    var target = document.querySelector(targetId);
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
      block: 'start'
    });

    window.setTimeout(function () {
      if (typeof target.focus === 'function') {
        target.focus({ preventScroll: true });
      }
    }, prefersReducedMotion ? 0 : 350);
  });

  var tabshows = document.querySelectorAll('[data-rsi-wo-tabshow]');

  tabshows.forEach(function (tabshow) {
    var tabs = tabshow.querySelectorAll('[data-rsi-wo-tab]');
    var panels = tabshow.querySelectorAll('[data-rsi-wo-panel]');

    function activate(tab) {
      tabs.forEach(function (item) {
        var isActive = item === tab;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        item.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach(function (panel) {
        var isActive = panel.id === tab.getAttribute('aria-controls');
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }

    tabshow.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-rsi-wo-tab]');
      if (!tab) return;
      activate(tab);
    });

    tabshow.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      var current = event.target.closest('[data-rsi-wo-tab]');
      if (!current) return;

      var tabList = Array.prototype.slice.call(tabs);
      var index = tabList.indexOf(current);
      var nextIndex = event.key === 'ArrowRight'
        ? (index + 1) % tabList.length
        : (index - 1 + tabList.length) % tabList.length;

      event.preventDefault();
      tabList[nextIndex].focus();
      activate(tabList[nextIndex]);
    });
  });

  var videoCarousels = document.querySelectorAll('[data-rsi-wo-video-carousel]');
  var CROSSFADE_MS = 1000;
  var READY_WAIT_MS = 1800;

  videoCarousels.forEach(function (stage) {
    var videoA = stage.querySelector('[data-rsi-wo-video="a"]');
    var videoB = stage.querySelector('[data-rsi-wo-video="b"]');
    var overlay = stage.querySelector('[data-rsi-wo-video-overlay]');
    if (!videoA || !videoB || !overlay) return;

    var sourcesAttr = videoA.getAttribute('data-rsi-wo-video-sources') || '';
    var sources = sourcesAttr.split(',').map(function (url) { return url.trim(); }).filter(Boolean);
    if (sources.length < 2) return;

    var activeEl = videoA;
    var idleEl = videoB;
    var activeIndex = 0;
    var idleIndex = null;
    var isVisible = true;
    var transitioning = false;

    // The first clip is already playing from the src set directly in Liquid
    // (progressive-enhancement fallback if this script never runs). Hand
    // control to the sequencer by dropping the native loop so `ended` fires.
    activeEl.loop = false;
    activeEl.classList.add('is-active');

    function nextIndex(i) {
      return (i + 1) % sources.length;
    }

    function attemptPlay(video) {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    // HAVE_FUTURE_DATA or better - enough buffered to start smoothly without
    // an immediate stall/black frame.
    function isReadyToPlay(video) {
      return video.readyState >= 3;
    }

    // Buffer the upcoming clip for the whole duration of the current one,
    // rather than only in the brief transition window, so playback doesn't stall.
    function preload(video, index) {
      idleIndex = index;
      video.preload = 'auto';
      video.src = sources[index];
      video.load();
    }

    preload(idleEl, nextIndex(activeIndex));

    function doSwap() {
      idleEl.currentTime = 0;
      attemptPlay(idleEl);

      // Restart the flash animation even if a previous cycle left the class
      // in place, so the white fade is consistent every time.
      overlay.classList.remove('is-flash');
      void overlay.offsetWidth;
      overlay.classList.add('is-flash');

      activeEl.classList.remove('is-active');
      idleEl.classList.add('is-active');

      var finishedEl = activeEl;
      activeEl = idleEl;
      idleEl = finishedEl;
      activeIndex = idleIndex;

      window.setTimeout(function () {
        idleEl.pause();
        transitioning = false;
        preload(idleEl, nextIndex(activeIndex));
      }, CROSSFADE_MS);
    }

    function advance() {
      if (transitioning || !isVisible) return;
      transitioning = true;

      if (isReadyToPlay(idleEl)) {
        doSwap();
        return;
      }

      // The upcoming clip isn't buffered enough yet - wait briefly for it
      // rather than cutting to an unloaded/black frame. Cap the wait so a
      // slow network never freezes the carousel indefinitely.
      var settled = false;

      function finish() {
        if (settled) return;
        settled = true;
        idleEl.removeEventListener('canplay', finish);
        idleEl.removeEventListener('loadeddata', finish);
        window.clearTimeout(fallback);
        doSwap();
      }

      var fallback = window.setTimeout(finish, READY_WAIT_MS);
      idleEl.addEventListener('canplay', finish);
      idleEl.addEventListener('loadeddata', finish);
    }

    // If the clip queued up next fails outright, move straight to the one
    // after it so the sequence keeps going instead of stalling forever.
    function skipBrokenIdle() {
      preload(idleEl, nextIndex(idleIndex));
    }

    videoA.addEventListener('ended', advance);
    videoB.addEventListener('ended', advance);

    videoA.addEventListener('error', function () {
      if (activeEl === videoA) advance();
      else if (idleEl === videoA) skipBrokenIdle();
    });
    videoB.addEventListener('error', function () {
      if (activeEl === videoB) advance();
      else if (idleEl === videoB) skipBrokenIdle();
    });

    if (window.IntersectionObserver) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isVisible = entry.isIntersecting;
          if (isVisible) {
            attemptPlay(activeEl);
          } else {
            activeEl.pause();
          }
        });
      }, { threshold: 0.1 });
      observer.observe(stage);
    }

    attemptPlay(activeEl);
  });

  var introRoots = document.querySelectorAll('[data-rsi-wo-intro]');
  var INTRO_FADE_MS = 750;

  introRoots.forEach(function (introRoot) {
    var introVideo = introRoot.querySelector('video');
    if (!introVideo) return;

    var settled = false;

    function complete() {
      if (settled) return;
      settled = true;
      introRoot.classList.add('is-intro-complete');
      window.setTimeout(function () {
        introRoot.classList.add('is-intro-hidden');
      }, INTRO_FADE_MS);
    }

    introVideo.addEventListener('ended', complete);
    introVideo.addEventListener('error', complete);

    if (prefersReducedMotion) {
      complete();
      return;
    }

    // Autoplay can still be blocked despite muted/playsinline (e.g. some
    // in-app browsers) - fall straight through to the existing loop rather
    // than sitting on a frozen first frame.
    var playPromise = introVideo.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(complete);
    }
  });
})();
